import React from 'react'
import { Button, Row, Form } from 'antd'
import { useTranslation } from 'next-i18next'
import { SyncOutlined } from '@ant-design/icons'
import ImportCabifyFile from './ImportCabifyFile'
import { transformArray } from 'src/core/helpers'
import { FootprintCalculusFormValues } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { getCalculateFootprintSelector, getFleetSelector } from 'src/features'
import { calculateFootprint } from 'src/features/manage-cabify-process/actions'
import { CustomCard, CustomCol, CustomTextInput, CustomSelect } from 'src/components'

const CalculateFootprint: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { loading, data } = useAppSelector(getFleetSelector)
  const { loading: loadingCalculate } = useAppSelector(getCalculateFootprintSelector)
  const [form] = Form.useForm()

  const handleSubmit = async (value: FootprintCalculusFormValues) => {
    if (!value.period || !value.cabifyFile || !value.fleetFile) {
      await form.validateFields()
      return
    }
    const payload = {
      csvFile: value.cabifyFile.file,
      fleetFile: value.fleetFile,
      period: value.period
    }
    dispatch(calculateFootprint(payload))
    form.resetFields()
  }

  return  <CustomCard
    cardTitle={t('Cabify.CalculateFootprints')}
    loading={loading}
  >
    <Form
      onFinish={handleSubmit}
      form={form}
    >
      <ImportCabifyFile />

      <Row className='mt-2'>
        <CustomCol className='p-2'>
          <CustomSelect
            name='fleetFile'
            showSearch
            required
            optionFilterProp='children'
            placeholder={t('Cabify.SelectFleet')}
            options={transformArray(data)}
            manageFiltering={(input, option) => {
              return String((option?.label ?? '')).toLowerCase().includes(input.toLowerCase())
            }}
          />

        </CustomCol>
        <CustomCol className='p-2'>
          <CustomTextInput
            name='period'
            placeholder={t('Cabify.SpecifyPeriod')}
            required
          />
        </CustomCol>
      </Row>

      <Button
        block
        size='middle'
        type='primary'
        htmlType='submit'
        className='radius-100'
        loading={loadingCalculate}
        icon={<SyncOutlined spin={loadingCalculate} />}
      >
        {loadingCalculate ? t('Cabify.CalculatingFootprint') : t('Cabify.CalculateFootprints')}
      </Button>
    </Form>
  </CustomCard>
}

export default CalculateFootprint
